import React, { useState, useContext, useEffect } from 'react';
import Label from 'components/formElements/Label';
import { FormContext } from 'context/FormContext';

const RangeSlider = (props) => {
    const { formValues, setFormValues } = useContext(FormContext);

    // NEW
    useEffect(() => {
        if (formValues[props.name] !== undefined) {
            setNetValue(Number(formValues[props.name]));
        }
    }, [formValues[props.name]]);
    //

    const getInitialRangeValue = () => {
        let value = Number(props.default);
        if (formValues[props.name] !== undefined) {
            value = Number(formValues[props.name]);
        }
        if (props.extra) {
            value += Number(props.extra || 0);
        }
        return value;
    };

    const getInitialNetValue = () => {
        let value = Number(props.default);
        if (formValues[props.name] !== undefined) {
            value = Number(formValues[props.name]);
        }
        return value;
    };

    const [rangeValue, setRangeValue] = useState(getInitialRangeValue());
    const [fillWidth, setFillWidth] = useState(getDefaultPercentage(getInitialRangeValue()));
    const [netValue, setNetValue] = useState(getInitialNetValue()); // value without extra

    useEffect(() => {
        // console.log('netValue Changed!', netValue);
        const extra = Number(props.extra || 0);
        let value = Number(netValue) + extra;
        value = Math.max(value, extra);
        setRangeValue(value);

        const max = parseFloat(props.max || 100);
        const min = parseFloat(props.min || 0);
        const percentage = 100 * (value - min) / (max - min);
        setFillWidth(percentage);
        setFormValues({ ...formValues, [props.name]: netValue });

    }, [netValue, props.extra]);

    const onChange = (e) => {
        const netValue = parseFloat(e.target.value) - Number(props.extra || 0);
        setNetValue(netValue);
        if (props.onChange) {
            props.onChange(e);
        }
    };

    return (
        <div className={`RangeSlider ${props.className}`}>
            <div className="d-flex justify-content-between">
                <Label text={props.label} info={props.info} />
                <div className="value"><span>{rangeValue}</span> {props.unit}</div>
            </div>

            <input
                type="range"
                onChange={onChange}
                name={props.name}
                style={{ background: `linear-gradient(90deg, #5CC244 ${fillWidth}%, #404B54 ${fillWidth}%)` }}
                value={rangeValue}
                min={props.min}
                max={props.max}
                step={props.step}
            />
        </div>
    );

    function getDefaultPercentage(value) {
        const max = Number(props.max || 100);
        const min = Number(props.min || 0);
        return 100 * (value - min) / (max - min);
    }
}

export default RangeSlider;